import React, { useEffect } from 'react';

const GoogleCallback: React.FC = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    const error = urlParams.get('error');

    const savedState = localStorage.getItem('google_oauth_state');

    if (error) {
      window.opener?.postMessage({
        type: 'GOOGLE_AUTH_ERROR',
        error: error === 'access_denied' ? 'Acesso negado pelo usuário' : 'Erro na autenticação'
      }, window.location.origin);
      window.close();
      return;
    }

    if (!code || !state || state !== savedState) {
      window.opener?.postMessage({
        type: 'GOOGLE_AUTH_ERROR',
        error: 'Estado inválido ou código não encontrado'
      }, window.location.origin);
      window.close();
      return;
    }

    window.opener?.postMessage({
      type: 'GOOGLE_AUTH_SUCCESS',
      token: code
    }, window.location.origin);
    
    window.close();
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontFamily: 'Inter, sans-serif'
    }}>
      <div>Processando autenticação...</div>
    </div>
  );
};

export default GoogleCallback;
